<template>
  <div v-if="show" :style="wrapperStyle">
    <v-alert
      v-model="alertShow"
      :type="type"
      prominent
      border="left"
      colored-border
      elevation="2"
      dismissible
      @input="onClose"
    >
      <v-icon left>{{ alertIcon }}</v-icon>
      <span>{{ text }}</span>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info',
      validator: value => ['info', 'warning', 'error'].includes(value)
    }
  },
  data() {
    return {
      alertShow: this.show
    };
  },
  computed: {
    wrapperStyle() {
      return `
        position: fixed;
        left: 50%;
        top: 65%;
        transform: translate(-50%, -50%);
        z-index: 9999;
        width: 400px;
        max-width: 90vw;
      `;
    },
    alertIcon() {
      const iconMap = {
        info: 'mdi-information',
        warning: 'mdi-alert',
        error: 'mdi-alert-circle'
      };
      return iconMap[this.type] || iconMap.info;
    }
  },
  watch: {
    show(val) {
      this.alertShow = val;
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
/* 確保 alert 在最上層 */
</style>
